"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const usa_time_picker_1 = __importDefault(require("@uswds/uswds/js/usa-time-picker"));
const usa_combo_box_1 = __importDefault(require("@uswds/uswds/js/usa-combo-box"));
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
const __1 = require("..");
const __2 = require("../..");
const TimePicker = (0, react_1.forwardRef)(({ children, className, disabled, error, hint, id, maxTime, minTime, onChange, placeholder, step, use24Hour, value }, ref) => {
    const containerRef = (0, react_1.useRef)(null);
    const timePickerRef = (0, react_1.useRef)(null);
    // initialization
    (0, react_1.useEffect)(() => {
        const containerEl = containerRef.current;
        if (!containerEl)
            return;
        // call USWDS's `on` functions to initialize the component
        usa_time_picker_1.default.on(containerEl);
        usa_combo_box_1.default.on(containerEl);
        // hook into the select's `change` event to monitor changes
        const selectEl = containerEl.querySelector('select');
        selectEl.addEventListener('change', (e) => {
            if (onChange)
                onChange(e);
        });
        // 24hr format
        if (use24Hour) {
            const options = containerEl.querySelectorAll('option');
            for (const option of options) {
                option.innerHTML = option.value;
            }
        }
        // on dismount, call USWDS's `off` functions to cleanup the component
        return () => {
            usa_combo_box_1.default.off(containerEl);
            usa_time_picker_1.default.off(containerEl);
        };
    }, []);
    // update the time picker's value whenever the value changes outside
    // of this component
    (0, react_1.useEffect)(() => {
        const timePickerEl = timePickerRef.current;
        if (!timePickerEl)
            return;
        const selectEl = timePickerEl.querySelector('select');
        const inputEl = timePickerEl.querySelector(`#${id}`);
        if (value !== selectEl.value) {
            selectEl.value = value || '';
            const valueOption = selectEl.querySelector(`option[value="${value}"]`);
            if (valueOption) {
                inputEl.value = valueOption.innerHTML;
            }
        }
    }, [value]);
    // call USWDS's `enable` or `disable` function when the disabled prop changes
    (0, react_1.useEffect)(() => {
        const timePickerEl = timePickerRef.current;
        if (!timePickerEl)
            return;
        const disabledState = timePickerEl.querySelector(`#${id}`).disabled;
        if (disabled === disabledState)
            return; // the input already has the right disabled state
        if (disabled)
            usa_combo_box_1.default.disable(timePickerEl);
        else
            usa_combo_box_1.default.enable(timePickerEl);
    }, [disabled]);
    const labelId = `${id}--label`;
    const hintId = `${id}--hint`;
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, uswds_react_utils_1.createClassString)('bah-uswds-time-picker', className), ref: containerRef, children: [(0, jsx_runtime_1.jsx)(__1.Label, { id: labelId, target: id, children: children }), hint && (0, jsx_runtime_1.jsx)(__2.Hint, { id: hintId, children: hint }), (0, jsx_runtime_1.jsx)(__1.Form.Error, { error: error }), (0, jsx_runtime_1.jsx)("div", { className: "usa-time-picker", "data-default-value": value, "data-max-time": maxTime, "data-min-time": minTime, "data-placeholder": placeholder, "data-step": step, ref: timePickerRef, children: (0, jsx_runtime_1.jsx)("input", { ref: ref, "aria-describedby": (0, uswds_react_utils_1.createClassString)(labelId, hint && hintId), className: "usa-input", disabled: disabled, id: id, name: id, type: "text" }) })] }));
});
exports.default = TimePicker;
